module.exports = kolibriGlobal.lib.vue;